import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import enhance from './ReviewContent.enhancer';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';

class CompleteDealForm extends React.Component {
  constructor() {
    super();
    this.state = {
      showSpinner: false,
      content: []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.deal) {
      this.props.firestore
        .collection('deals')
        .doc(nextProps.deal.id)
        .collection('content')
        .get()
        .then(contentSnapshot => {
          if (contentSnapshot.docs.length) {
            const submittedContent = contentSnapshot.docs.map(contentDoc => {
              return contentDoc.data();
            });
            this.setState({
              content: submittedContent
            });
          }
        });
    }
  }

  closeDrawer() {
    this.props.closeClick();
  }

  acceptContent(deal) {
    this.setState({
      showSpinner: true
    });

    this.props.acceptContent(
      deal.paymentId,
      deal.currentProposal.payout,
      deal.influencerId,
      deal.companyId,
      deal.id,
      this.onAcceptComplete
    );
  }

  onAcceptComplete = () => {
    this.setState({
      showSpinner: false
    });
    this.closeDrawer();
  };

  render() {
    const { classes, open, deal, escrowReleaseIsProcessing } = this.props;
    const { content, showSpinner } = this.state;
    return (
      <Drawer onClose={this.closeDrawer.bind(this)} anchor="right" open={open}>
        <div className={classes.root} role="presentation">
          <React.Fragment>
            <Typography variant="h5" align="center">
              Review Content
            </Typography>
            <Divider />
            {content &&
              content.length > 0 &&
              content.map(contentItem => (
                <Paper className={classes.contentContainer}>
                  <Typography>
                    Submitted on{' '}
                    {moment(contentItem.timestamp.toDate()).format(
                      'MM/DD/YYYY'
                    )}
                  </Typography>
                  <Typography className={classes.contentLink}>
                    <a
                      target="_blank"
                      href={contentItem.contentLink}
                      className={classes.contentLink}
                    >
                      Content Link: {contentItem.contentLink}
                    </a>
                  </Typography>
                  <div className={classes.youtubeVideoUpload}>
                    <iframe
                      className={classes.iframeContainer}
                      width="170"
                      height="170"
                      src={`https://www.youtube.com/embed/${contentItem.videoId}`}
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    />
                  </div>
                </Paper>
              ))}

            <div className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                className={classes.acceptButton}
                onClick={() => this.acceptContent(deal)}
              >
                Accept Content
              </Button>
              <Button
                color="secondary"
                variant="outlined"
                // className={classes.contentSection}
                onClick={() =>
                  this.props.handleOpenDispute(deal.id, deal.companyId)
                }
              >
                Reject and Open Dispute
              </Button>
            </div>
          </React.Fragment>
        </div>
        {showSpinner && (
          <div className={classes.spinnerContainer}>
            <CircularProgress className={classes.downArrow} />
          </div>
        )}
      </Drawer>
    );
  }
}

export default enhance(CompleteDealForm);



// WEBPACK FOOTER //
// ./src/components/deals/content-review/ReviewContent.js